import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ApiService } from './api.service';
import { TokenStorageService } from './token-storage.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private api = inject(ApiService);
  private storage = inject(TokenStorageService);
  private router = inject(Router);

  async login(email: string, password: string) {
    const res = await firstValueFrom(this.api.login(email, password));
    const token = res?.data?.token;
    if (!token) throw new Error('Invalid login response');
    this.storage.setToken(token);
  }

  async requestPasswordReset(email: string) {
    return await firstValueFrom(this.api.requestPasswordReset(email));
  }

  async resetPassword(email: string, code: string, password: string) {
    return await firstValueFrom(this.api.resetPassword(email, code, password));
  }

  logout() { 
    this.storage.clear();
    this.router.navigate(['/login']);
  }

  get token() { return this.storage.getToken(); }
  get isAuthenticated() { return !!this.token; }
}
